module.exports = __webpack_public_path__ + "static/media/doc.7397528b.png";